import { Pipe, PipeTransform } from '@angular/core';
import { ShellDomainProvider } from "@ecap3/core";

@Pipe({
  name: 'checkEmpty'
})

export class CheckEmptyPipe implements PipeTransform {

  transform(value: any): any {
    const checkEmptyV1 = () => {
      if (!value || value === 0 || value === "") {
        return '-';
      } else {
        return value;
      }
    }
    const checkEmptyV2 = () => {
      if (value) {
        if(typeof value === 'string') {
          const trimmedValue = value.trim();
          if(trimmedValue) {
            return value;
          } else {
            return '-';
          }
        } else {
          return value;
        }
      } else {
        if(typeof value === 'number') {
          if(value === 0) {
            return value;
          } else {
            return '-'
          }
        } else {
          return '-';
        }
      }
    }

    const version = ShellDomainProvider['api'] && ShellDomainProvider["api"]["checkEmptyPipeVersion"] ? ShellDomainProvider["api"]["checkEmptyPipeVersion"] : 'v1';
    const checkEmpty = {
      v1: checkEmptyV1,
      v2: checkEmptyV2
    }
    return checkEmpty[version]();
  }
}
